module.exports = __webpack_public_path__ + "img/title_entery.c37c64da.png";